export default __webpack_public_path__ + "static/media/LOCKETGO_LOGO_RVB-Blanc.c45760c3.svg";